import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MessageBoxParameter } from '@classes/message-box-parameter';
import { SiteMode } from '@classes/site-mode';
import { MessageBox } from '@components/message-box/message-box.component';
import { TranslateService } from '@ngx-translate/core';
import { SiteModeService } from 'app/core/services/site-mode.service';
import { UiService } from 'app/core/services/ui.service';
import { SiteModeDetailComponent } from '../site-mode-detail/site-mode-detail.component';
import { Role } from '@enums/role.enum';

@Component({
  selector: 'app-site-mode-grid',
  templateUrl: './site-mode-grid.component.html',
  styleUrls: ['./site-mode-grid.component.scss']
})
export class SiteModeGridComponent implements OnInit {

  dataSource = new MatTableDataSource<SiteMode>();
  pageSizeOptions = [25, 50, 100];
  selectedRowID: string;
  displayedColumns: string[] = [
    'name',
    // 'modifiedDate',
    // 'userName',
    'action'
  ];

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) MatPaginatorSiteMode: MatPaginator;

  Role = Role;

  constructor(
    public siteModeService: SiteModeService,
    public uiService: UiService,
    public dialog: MatDialog,
    public translateService: TranslateService
  ) { }

  ngOnInit() {
    this.getSiteModes();
  }
  getSiteModes() {
    this.uiService.addRouteLoading();
    this.siteModeService.getSiteModes().subscribe(siteMode => {
      this.dataSource.data = siteMode;
      this.uiService.removeRouteLoading();
    }, error => {
      console.error(error);
      this.uiService.removeRouteLoading();
    });
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.MatPaginatorSiteMode;
    this.dataSource.sortingDataAccessor = (data: any, sortHeaderId: string): string => {
      if (typeof data[sortHeaderId] === 'string') {
        return data[sortHeaderId].toLocaleLowerCase();
      }
    
      return data[sortHeaderId];
    };
  }

  selectItemClick(item: SiteMode) {
    this.selectedRowID = item.id || '';
  }
  editElement(item: SiteMode) {
    const data = new SiteMode({
      id: item.id || "",
      name: item.name || ""
    });
    const dialogRef = this.dialog.open(SiteModeDetailComponent, {
      data,
      hasBackdrop: true
    });
    dialogRef.afterClosed().subscribe(success => {
      if (success) {
        this.getSiteModes();
      }
    });
  }

  onDelete(item: SiteMode) {
    if (item && item.id) {

      const messageBoxParameter = new MessageBoxParameter();

      messageBoxParameter.message = this.translateService.instant('site-mode.confirm-delete');
      messageBoxParameter.dialog = this.dialog;
      messageBoxParameter.title = 'Confirmation';
      messageBoxParameter.buttons = ['yes', 'no'];
      messageBoxParameter.width = "400px";

      MessageBox.show(messageBoxParameter).subscribe(mbResult => {
        if (mbResult && mbResult.value) {
          this.uiService.addRouteLoading();
          this.siteModeService.deleteSiteMode(item?.id || "").subscribe(data => {
            this.uiService.displayMessageToast('site-mode.success-delete');
            this.uiService.removeRouteLoading();
            this.getSiteModes();
          }, error => {
            console.error(error);
            this.uiService.removeRouteLoading();
          });
        }
      });
    }
  }

}
